import './marshall.css';
import imgMarshall from '../../assets/marshall/marshall.png';
import EllipseBg from '../../assets/marshall/EllipseBg.png';
import eardopes from '../../assets/marshall/eardopes.png';
import { useNavigate } from 'react-router-dom';

function MarshallLandingPage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="marshall-landing-container">
        {/* Left Part */}
        <div className="marshall-left-header">
          <div className="marshall-title">
            <img src={imgMarshall} alt="Marshall-Title" />
          </div>
          <h1 className="marshall-heading">Play Your Music</h1>
          <p className="marshall-para">
            Meet Mode II, the first true wireless in-ear Bluetooth headphones
            from Marshall. Mode II is relentless, delivering 5 hours of wireless
            playtime in the earbuds on a single charge with a portable charging
            case that carries four additional charges. Engineered to deliver a
            thunderous audio experience, Mode II produces phenomenal sound with
            no wires attached.
          </p>
          <button
            className="marshall-button"
            onClick={() => navigate('/contactus')}
            style={{ position: 'relative', zIndex: 10 }}
          >
            Contact Us
          </button>
        </div>

        {/* Right Part */}
        <div className="marshall-right-header">
          <div className="marshall-img-container">
            <div className="marshall-bg-container">
              <img src={EllipseBg} alt="Ellipse-background" />
            </div>
            <div className="marshall-eardopes-container">
              <img src={eardopes} alt="eardopes" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MarshallLandingPage;
